import React, { Component } from "react";
import { Row, Col, Form, Select, Input, Tabs, Table } from "antd";
import { changeFormatdate, changeFormatFulldate } from "../../../../../utils/formatdate";

const { TabPane } = Tabs;

class SecProfileInformation extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "sort",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return <>{this.state.pageData.offset + index + 1}</>;
        },
      },
      {
        title: "วันที่ดำเนินการ",
        dataIndex: "actionDate",
        align: "center",
        // width:'200px',
        vertical: "top",
        render: (item, record, index) => {
          return (
            <>
              {this.props.rawData && (
                <span>
                  {item ? changeFormatFulldate(
                    item ): "-"}
                </span>
                )}
            </>
          );
        },
      },
      {
        title: "ผู้ดำเนินการ",
        dataIndex: "actionByName",
        vertical: "top",
        //width:'200px',
        align: "center",
        render: (item, record, index) => {
          return (
            <>
               {this.props.rawData && (
                <span>
                   {item ? item : "-"}
                </span>
                )}
            </>
          );
        },
      },
      {
        title: "การดำเนินการ",
        dataIndex: "actionName",
        //width:'200px',
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {this.props.rawData && (
                <span>
                  {item ? item : "-"}
                </span>
                )}
            </>
          );
        },
      },
      {
        title: "สถานะ",
        dataIndex: "statusName",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {this.props.rawData && (
                <span>
                  {item ? item : "-"}
                </span>
                )}
            </>
          );
        },
      },
      // {
      //   title: "หมายเหตุ",
      //   dataIndex: "9",
      //   width: "200px",
      //   vertical: "top",
      //   align: "center",
      //   render: (item, record, index) => {
      //     return (
      //       <>
      //        {this.props.rawData && (
      //           <span>
      //             {item ? item : "-"}
      //           </span>
      //           )}
      //       </>
      //     );
      //   },
      // },
    ],
    pageData: {
      offset: 0,
      limit: 10,
    },
  };

  render() {
    const { propFormInput, isViewOnly, rawData } = this.props;
    const {columns} = this.state;


    console.log("rawData History",rawData)
    return (
      <div>
        <Row gutter={16} type="flex" justify="left" align="top">
          <Col xs={24} md={24} className="pt-0">
            <strong className="color-red">ประวัติการดำเนินการ</strong>
          </Col>
        </Row>
        <Col xs={24} md={24} align={"right"} className="pt-4">
          <Table
            columns={columns}
            dataSource={rawData ? rawData : []}
            className="mb-3"
            bordered
            rowCount={rawData?.length}
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            // pagination={{ defaultPageSize: 5,}}
            pagination={false}
            scroll={{ x: "max-content" }}
          />
        </Col>
      </div>
    );
  }
}

export default SecProfileInformation;
